/**
 * Silensia Recovery -- header reveal on scroll up.
 *
 * The header is position:sticky at the top of the page. Scrolling DOWN
 * slides it out of the way; scrolling UP brings it straight back, so the
 * navigation and "Speak to us" are always one small gesture away without
 * the bar sitting permanently over the photography.
 *
 * Two details this has to get right on this theme specifically:
 *
 * 1. The scrolling element is NOT the window. layout/theme.liquid scrolls
 *    `.page-wrapper`, so a plain window scroll listener never fires. The
 *    scroller is resolved at run time and falls back to the window for any
 *    template where that is not true.
 *
 * 2. The header must never hide while the mobile navigation dialog is
 *    open -- the dialog's own trigger lives inside the header.
 *
 * Progressive enhancement: with JavaScript off the header simply stays
 * sticky and always visible, which is a perfectly good state. Nothing here
 * hides content by default; `.is-hidden` is only ever added by this file.
 */
(function () {
  'use strict';

  var header = document.querySelector('.silensia-header');
  if (!header) return;

  // The element that is actually sticky, and therefore the one that has to
  // carry the class: Shopify's own header section group. See the note in
  // sections/silensia-header.liquid -- sticky on .silensia-header itself
  // has no travel room inside its .shopify-section wrapper and does
  // nothing at all. Falls back to the header if the group is ever absent.
  var target = document.getElementById('header-group') || header;

  // Never animate for readers who have asked not to: they get a header
  // that is simply always there.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var wrapper = document.querySelector('.page-wrapper');

  // Which element scrolls is NOT fixed for the life of the page: measured
  // live on this theme, `.page-wrapper` is the scroller at desktop widths
  // while the document itself scrolls at mobile widths. Resolving it once
  // at load would leave the listener attached to the wrong target for
  // anyone who crosses that breakpoint by resizing or rotating a tablet.
  //
  // So the position is read from whichever element is actually scrolled,
  // every time, and the listener is attached to BOTH. Only one of them
  // ever moves, so there is no double counting.
  function currentY() {
    if (wrapper && wrapper.scrollTop > 0) return wrapper.scrollTop;
    var docY = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (docY > 0) return docY;
    return wrapper ? wrapper.scrollTop : 0;
  }

  var lastY = currentY();
  var ticking = false;

  // Below this, the header always shows: near the top of the page there is
  // nothing to gain by hiding it, and hiding it there makes the first
  // scroll feel twitchy.
  var TOP_ZONE = 80;
  // Movement smaller than this is ignored, so a trackpad's own jitter or
  // the rubber-band at the end of a page cannot flip the header.
  var MIN_DELTA = 6;

  function update() {
    ticking = false;
    var y = currentY();
    var delta = y - lastY;

    if (Math.abs(delta) < MIN_DELTA) return;

    var dialog = document.getElementById('silensia-page-index-dialog');
    var dialogOpen = !!dialog && dialog.open;

    if (y <= TOP_ZONE || dialogOpen) {
      target.classList.remove('is-hidden');
    } else if (delta > 0) {
      target.classList.add('is-hidden');
    } else {
      target.classList.remove('is-hidden');
    }

    lastY = y;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
})();
